import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { withTranslation } from 'react-i18next'
import './item.css'

class Item extends Component {

    static propTypes = {
        name: PropTypes.string.isRequired,
        onClick: PropTypes.func.isRequired,
        isSelected: PropTypes.bool.isRequired,
        isDisabled: PropTypes.bool,
        icon: PropTypes.string.isRequired,
        selectedIcon: PropTypes.string,
        highlightOnSelect: PropTypes.bool,
        isItemDisplayable: PropTypes.func.isRequired,
        title: PropTypes.string.isRequired,
        t: PropTypes.func.isRequired,
    }

    icon = () => (this.props.selectedIcon !== undefined && this.props.isSelected ? this.props.selectedIcon : this.props.icon)

    render()
    {
        const { isSelected, isDisabled, onClick, title, isItemDisplayable, t, highlightOnSelect = true } = this.props

        if(! isItemDisplayable())
        {
            return <div />
        }

        return (
            <button
                className={classNames('item', {'selected': isSelected && highlightOnSelect})}
                onClick={onClick}
                title={t(title)}
                disabled={ isDisabled ? 'disabled' : '' }
            >
                <span aria-hidden="true" className={classNames(this.icon())} />
            </button>
        )
    }
}

export default withTranslation()(Item)
